import { useKyronQuery } from './kyronQuery';

export const useTitlesQuery = (numberOfTitles: number, enabled: boolean, learningEnvironment?: string) =>
  useKyronQuery<string[]>(
    `/feeling_lucky/generate_titles?number_of_titles=${numberOfTitles}&learning_environment=${learningEnvironment}`,
    { enabled },
  );
